export class RegisterDTO {
    phoneNumber: string = "";
    fullName: string = "";
    email: string = "";
    password: string = ""
}